import React, { useState, useContext } from 'react'
import { useQuery, useLazyQuery } from '@apollo/client'
import { useAlert } from 'react-alert'
import useDebouncedEffect from 'use-debounced-effect-hook'
import Typography from '@material-ui/core/Typography'
import CircularProgress from '@material-ui/core/CircularProgress'
import Grid from '@material-ui/core/Grid'
import UsersGrid from './components/UsersGrid'
import { useStyles } from './styles'
import { GET_USERS_LIST } from '../../network/management/queries'
import { GET_WAVES_LIST } from '../../network/progress/queries'
import { ALL_USERS_FILTER, NO_USERS_FILTER } from '../../constants/common'
import { LabContext } from '../../context'

const ManagementPage = () => {
  const classes = useStyles()
  const alert = useAlert()
  const { selectedLab, selectedAccount } = useContext(LabContext)
  const [waveFilterValue, setWaveFilterValue] = useState(ALL_USERS_FILTER)
  const [filterText, setFilterText] = useState('')
  const [users, setUsers] = useState([])

  const searchInputHandler = e => {
    setFilterText(e.target.value)
  }

  const { loading: wavesLoading, data: wavesData } = useQuery(GET_WAVES_LIST, {
    skip: !selectedLab,
    fetchPolicy: 'no-cache',
    variables: {
      labId: selectedLab,
      accountIds: selectedAccount ? [selectedAccount] : undefined
    },
    onError: error => {
      alert.show(error.message, {
        type: 'error'
      })
    }
  })

  const [getUsersList, { loading: usersLoading }] = useLazyQuery(GET_USERS_LIST, {
    fetchPolicy: 'no-cache',
    variables: {
      labId: selectedLab,
      accountIds: selectedAccount ? [selectedAccount] : undefined
    },
    onError: error => {
      setUsers([])
      alert.show(error.message, {
        type: 'error'
      })
    },
    onCompleted: data => {
      setUsers(data.coordinator.user.list)
    }
  })

  const handleDownloadUsersList = () => {
    if (selectedLab && (!filterText || (filterText && filterText.length >= 3))) {
      getUsersList({
        variables: {
          waveIds:
            waveFilterValue.id === ALL_USERS_FILTER.id
              ? undefined
              : waveFilterValue.id === NO_USERS_FILTER.id
              ? [null]
              : [waveFilterValue.id],
          text: filterText || undefined
        }
      })
    }
  }

  useDebouncedEffect(
    () => handleDownloadUsersList(),
    [selectedLab, filterText, waveFilterValue.id],
    650 // The debounce delay
  )

  const handleWaveFilterChange = value => {
    setWaveFilterValue(value)
  }

  return wavesLoading || !selectedLab ? (
    <div className={classes.loader}>
      <CircularProgress color='inherit' />
    </div>
  ) : (
    <div className={classes.root}>
      <Grid container spacing={6}>
        <Grid container item xs={12}>
          <Typography variant='h2' component='div'>
            Management
          </Typography>
        </Grid>
        <Grid container item xs={12}>
          <UsersGrid
            usersLoading={usersLoading}
            users={users}
            waves={wavesData.coordinator.wave.list}
            handleWaveFilterChange={handleWaveFilterChange}
            waveFilterValue={waveFilterValue}
            filterText={filterText}
            searchInputHandler={searchInputHandler}
          />
        </Grid>
      </Grid>
    </div>
  )
}

export default ManagementPage
